import { GlobalState } from 'ha/types/store';
import { FetchStatus } from 'ha/types/FetchStatus';

import { STATE_NAME } from '../constants';

export const getSupportedCountriesFetchStatus = (
  state: GlobalState,
): FetchStatus => state[STATE_NAME].supportedCountriesFetchStatus;

export const getSupportedCurrenciesFetchStatus = (
  state: GlobalState,
): FetchStatus => state[STATE_NAME].supportedCurrenciesFetchStatus;

export const getSupportedCountries = (state: GlobalState): string[] =>
  state[STATE_NAME].supportedCountries;

export const getSupportedCurrencies = (state: GlobalState): string[] =>
  state[STATE_NAME].supportedCurrencies;
